import {Injectable} from '@angular/core';
import {NavService} from './nav-service';
import {Router} from '@angular/router';
import {EparcoursPath} from '../../constantes/menu/menu-items/eparcours-path';

@Injectable({
  providedIn: 'root',
})
export class UtilisateursNavService extends NavService {
  constructor(router: Router) {
    super(router);
  }

  liste = this.makeNavigator(EparcoursPath.root.UTILISATEURS);

  creation = this.makeNavigator(
    EparcoursPath.root.UTILISATEURS,
    EparcoursPath.utilisateurs.EDITION,
    EparcoursPath.utilisateurs.EDITION_GENERAL,
  );

  edition_by_id = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.UTILISATEURS,
    EparcoursPath.utilisateurs.EDITION,
  );
}
